<template>
  <div class="trips-container">
    <nav class="breadcrumb">
      <router-link to="/">Home</router-link> /
      <span>Trips</span>
    </nav>

    <h2 class="title">Trips</h2>

    <div v-if="loading" class="state">Loading trips...</div>
    <div v-else-if="error" class="state error">{{ error }}</div>
    <div v-else-if="trips.length === 0" class="state">No trips found.</div>

    <div v-else class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Date</th>
            <th>Start</th>
            <th>End</th>
            <th>Students</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="trip in trips" :key="trip.id">
            <td>{{ trip.name }}</td>
            <td>{{ trip.date }}</td>
            <td>{{ trip.startTime }}</td>
            <td>{{ trip.endTime }}</td>
            <td>{{ trip.students.length }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { API_URL } from "../config";
import { getErrorMessage } from "../types";
import type { TripRecord } from "../types";

interface Trip extends TripRecord {
  students: Array<{ id: number }>;
}

const trips = ref<Trip[]>([]);
const loading = ref(true);
const error = ref("");

const fetchTrips = async () => {
  loading.value = true;
  error.value = "";
  try {
    const response = await fetch(`${API_URL}/trips`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (!response.ok) {
      throw new Error("Failed to load trips");
    }
    trips.value = await response.json();
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to load trips");
  } finally {
    loading.value = false;
  }
};

onMounted(fetchTrips);
</script>

<style scoped>
.trips-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.table-wrap {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  text-align: left;
  border-bottom: 1px solid #ddd;
  padding: 10px;
}

th {
  background: #f8f9fa;
}

.state {
  margin-top: 12px;
}

.error {
  color: #b00020;
}
</style>
